/* =============================================================
   MINIALPPACA — Collection JS
   - Filter accordion
   - Mobile sidebar toggle
   - View toggle (2/3/4 colunas)
   - Form de filtros: auto-submit (debounce em inputs numéricos)
   - Sort: atualiza apenas sort_by preservando demais query params
   - Quick add via /cart/add.js (AJAX, sem reload)
   - Reveal on scroll
============================================================= */

(function () {
  'use strict';

  // ── Filter accordion ──
  document.querySelectorAll('.filter-group-header').forEach(function (h) {
    h.addEventListener('click', function () {
      var group = h.parentElement;
      group.classList.toggle('open');
      h.setAttribute('aria-expanded', group.classList.contains('open'));
    });
  });

  // ── Mobile sidebar ──
  var sidebar = document.getElementById('FiltersSidebar');
  var overlay = document.getElementById('SidebarOverlay');
  var mobileBtn = document.getElementById('MobileFilterBtn');
  var closeBtn = document.getElementById('SidebarClose');

  function openSidebar() {
    if (!sidebar) return;
    sidebar.classList.add('open');
    if (overlay) overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
  function closeSidebar() {
    if (!sidebar) return;
    sidebar.classList.remove('open');
    if (overlay) overlay.style.display = 'none';
    document.body.style.overflow = '';
  }
  if (mobileBtn) mobileBtn.addEventListener('click', openSidebar);
  if (overlay) overlay.addEventListener('click', closeSidebar);
  if (closeBtn) closeBtn.addEventListener('click', closeSidebar);

  // ── View toggle (colunas do grid) ──
  var grid = document.getElementById('ProductsGrid');
  var STORAGE_KEY = 'mp_grid_cols';

  function applyCols(n) {
    if (!grid) return;
    grid.classList.remove('grid-2', 'grid-3', 'grid-4');
    grid.classList.add('grid-' + n);
    document.querySelectorAll('[data-grid-cols]').forEach(function (b) {
      b.classList.toggle('active', b.dataset.gridCols === String(n));
    });
  }

  document.querySelectorAll('[data-grid-cols]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var n = btn.dataset.gridCols;
      applyCols(n);
      try { localStorage.setItem(STORAGE_KEY, n); } catch (e) {}
    });
  });

  try {
    var saved = localStorage.getItem(STORAGE_KEY);
    if (saved && grid) applyCols(saved);
  } catch (e) {}

  // ── Filter form auto-submit ──
  var filterForm = document.getElementById('CollectionFilterForm');
  if (filterForm) {
    var submitTimer;
    filterForm.addEventListener('change', function (e) {
      var t = e.target;
      // Inputs numéricos (preço): debounce
      if (t && (t.type === 'number' || t.type === 'text')) {
        clearTimeout(submitTimer);
        submitTimer = setTimeout(function () { filterForm.submit(); }, 700);
      } else {
        filterForm.submit();
      }
    });
    // Submit em Enter dentro de inputs numéricos
    filterForm.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); filterForm.submit(); }
    });
  }

  // ── Show more / Show less toggle (filter sidebar) ──
  document.querySelectorAll('[data-show-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var listId = btn.getAttribute('aria-controls');
      var list = listId && document.getElementById(listId);
      if (!list) return;
      var overflow = list.querySelectorAll('.filter-overflow');
      overflow.forEach(function (el) {
        if (expanded) { el.setAttribute('hidden', ''); }
        else { el.removeAttribute('hidden'); }
      });
      btn.setAttribute('aria-expanded', String(!expanded));
      var label = btn.querySelector('[data-show-more-text]');
      if (label) {
        label.textContent = expanded
          ? ('ver mais (' + overflow.length + ')')
          : 'ver menos';
      }
    });
  });

  // ── Sort select ──
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // ── Quick add via AJAX ──
  function bindQuickAdd(form) {
    if (form.dataset.qaBound === '1') return;
    form.dataset.qaBound = '1';
    var variantInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('.btn-quick-add');
    var defaultLabel = addBtn ? addBtn.textContent : '+ Adicionar';

    // Pré-seleciona a primeira variante disponível, se houver
    var firstAvailable = form.querySelector('.sq-tag[data-variant-id]:not(:disabled)');
    if (firstAvailable && variantInput && !variantInput.value) {
      // Não pré-seleciona visualmente — UX exige clique explícito do tamanho.
      // Mas seta a primeira disponível para evitar erro caso o usuário pule a seleção.
      // (comente a linha abaixo se quiser obrigar a seleção manual)
      // variantInput.value = firstAvailable.dataset.variantId;
    }

    form.querySelectorAll('.sq-tag[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        form.querySelectorAll('.sq-tag').forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
        if (variantInput) variantInput.value = btn.dataset.variantId;
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variantInput || !variantInput.value) {
        if (addBtn) {
          addBtn.textContent = 'Selecione um tamanho';
          setTimeout(function () { addBtn.textContent = defaultLabel; }, 1800);
        }
        return;
      }
      var fd = new FormData(form);
      if (addBtn) { addBtn.textContent = 'Adicionando...'; addBtn.disabled = true; }

      fetch(window.Shopify && window.Shopify.routes ? (window.Shopify.routes.root + 'cart/add.js') : '/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/javascript' }
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          if (addBtn) {
            addBtn.textContent = '✓ Adicionado';
            setTimeout(function () {
              addBtn.textContent = defaultLabel;
              addBtn.disabled = false;
            }, 1500);
          }
        })
        .catch(function (err) {
          console.error('[QuickAdd] erro:', err);
          if (addBtn) {
            addBtn.textContent = (err && err.description) ? err.description : 'Erro — tente novamente';
            setTimeout(function () {
              addBtn.textContent = defaultLabel;
              addBtn.disabled = false;
            }, 2000);
          }
        });
    });
  }
  document.querySelectorAll('[data-quick-add-form]').forEach(bindQuickAdd);

  // ── Reveal on scroll (reutilizável p/ cards anexados) ──
  var revealObserver = null;
  function observeReveal(els) {
    if (!els || !els.length) return;
    if ('IntersectionObserver' in window) {
      if (!revealObserver) {
        revealObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.08 });
      }
      els.forEach(function (el) { revealObserver.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('visible'); });
    }
  }
  observeReveal(document.querySelectorAll('.reveal'));

  // ── Carregar mais: infinite/lazy load via AJAX ──
  (function () {
    var area = document.querySelector('[data-load-more-area]');
    var gridEl = document.querySelector('[data-products-grid]');
    if (!area || !gridEl) return;

    function setLoading(btn, on) {
      var label = btn.querySelector('[data-load-more-label]');
      if (on) {
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'Carregando...';
      } else {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        if (label) label.textContent = 'Carregar mais';
      }
    }

    area.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-load-more]');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      var url = btn.getAttribute('href');
      if (!url) return;
      setLoading(btn, true);

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          // Anexa os novos cards (snapshot p/ não iterar coleção viva)
          var newGrid = doc.querySelector('[data-products-grid]');
          var added = [];
          if (newGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (card) {
              if (card.classList && card.classList.contains('empty-state')) return;
              card.classList.add('reveal');
              card.classList.remove('visible');
              gridEl.appendChild(card);
              added.push(card);
            });
          }

          // Re-vincula quick add + anima entrada dos novos cards
          added.forEach(function (card) {
            card.querySelectorAll('[data-quick-add-form]').forEach(bindQuickAdd);
          });
          requestAnimationFrame(function () { observeReveal(added); });

          // Atualiza contador "Mostrando X de Y"
          var newShown = doc.querySelector('[data-load-shown]');
          var shownEl = area.querySelector('[data-load-shown]');
          var totalEl = area.querySelector('[data-load-total]');
          var barEl = area.querySelector('[data-load-bar]');
          if (newShown && shownEl) shownEl.textContent = newShown.textContent;

          // Atualiza barra de progresso
          if (shownEl && totalEl && barEl) {
            var s = parseInt((shownEl.textContent || '').replace(/\D/g, ''), 10);
            var t = parseInt((totalEl.textContent || '').replace(/\D/g, ''), 10);
            if (s && t) barEl.style.width = Math.min(100, Math.round(s / t * 100)) + '%';
          }

          // Próxima página: atualiza href ou oculta o botão no fim
          var newBtn = doc.querySelector('[data-load-more]');
          if (newBtn && newBtn.getAttribute('href')) {
            btn.setAttribute('href', newBtn.getAttribute('href'));
            setLoading(btn, false);
          } else {
            btn.remove();
          }
        })
        .catch(function (err) {
          console.error('[LoadMore]', err);
          setLoading(btn, false);
          var label = btn.querySelector('[data-load-more-label]');
          if (label) label.textContent = 'Tentar novamente';
        });
    });
  })();
})();
